<kendo-dialog-titlebar (close)="cancel()">
  <div class="ss-dialog-title">
    {{ title | translate }}
  </div>
</kendo-dialog-titlebar>
<!-- CONTENT -->

<div class="ss-popup-container">
  <kendo-grid
    [data]="gridView"
    [pageSize]="state.take"
    [skip]="state.skip"
    [sort]="state.sort"
    [filter]="state.filter"
    [sortable]="true"
    [pageable]="pageable"
    [filterable]="true"
    [resizable]="true"
    [selectable]="gridService.selectableSettings"
    scrollable="scrollable"
    [loading]="isLoading"
    class="ss-list-grid"
    (cellClick)="select($event)"
    (dataStateChange)="dataStateChange($event)"
  >
    <!-- COLUMNS -->

    <!-- ID -->

    <kendo-grid-column
      field="productItemId"
      title="{{ 'module.product-item.model.productItemId' | translate }}"
      [width]="40"
      filter="numeric"
      format="0n0"
    ></kendo-grid-column>

    <!-- CODE SPI -->

    <kendo-grid-column
      field="productItemNumber"
      title="{{ 'module.product-item.model.productItemNumber' | translate }}"
      [width]="60"
    ></kendo-grid-column>

    <!-- TITRE -->

    <kendo-grid-column
      [field]="productItemTitle"
      title="{{ 'module.product-item.model.productItemTitle' | translate }}"
      [width]="180"
    ></kendo-grid-column>

  </kendo-grid>
</div>
